// authStorage.js
import jwt_decode from 'jwt-decode'

/**
 * Generic localStorage helpers
 */
const storage = {
  set: (key, value) =>
    localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value)),
  get: (key) => {
    const value = localStorage.getItem(key)
    if (!value) return null

    // Only parse if it looks like JSON
    if (value.startsWith('{') || value.startsWith('[')) {
      try {
        return JSON.parse(value)
      } catch (err) {
        console.warn(`Failed to parse JSON from localStorage key "${key}"`, err)
        return null
      }
    }
    return value
  },
  remove: (key) => localStorage.removeItem(key),
}

// ----- Auth Token -----
export const setAuthToken = (token) => token && storage.set('token', token)
export const getAuthToken = () => storage.get('token')
export const clearAuthToken = () => storage.remove('token')

// ----- Impersonation Token -----
export const setImpersonationToken = (token) => {
  if (!token) return
  try {
    const decoded = jwt_decode(token)
    storage.set('effectiveToken', token)
    storage.set('impersonatedUser', decoded?.user || {})
  } catch (err) {
    console.error('Invalid impersonation token', err)
  }
}
export const getImpersonationToken = () => storage.get('effectiveToken')
export const getImpersonationUserInfo = () => storage.get('impersonatedUser')
export const setSelectedSupportAccount = (account) => storage.set('selectedSupportAccount', account)
export const getSelectedSupportAccount = () => storage.get('selectedSupportAccount')
export const clearImpersonationToken = () => {
  ;['effectiveToken', 'impersonatedUser', 'selectedSupportAccount'].forEach(storage.remove)
}

// ----- Other User Data -----
export const clearTokenData = () => {
  ;['userName', 'timeZone', 'userType', 'userEmail'].forEach(storage.remove)
}
export const getUserType = () => storage.get('userType')
